import { FontAwesome } from '@expo/vector-icons';

import type { Icon } from './internal';

export const SortAmountDesc: Icon = ({ color = '#000000', size = 24 }) => (
  <FontAwesome name="sort-amount-desc" size={size} color={color} />
);
